// chartBaseConfig.js
export const chartBaseJsonConfig = {
  // Define base config as a function to easily merge with specific settings
  applyBaseConfig: (specificSettings) => {
    const baseConfig = {
      // Base styling applied to all charts
      chart: {
        fontFamily: "SF Pro Display, sans-serif",
        background: {
          fill: "#fff"
        }
      },
      title: {
        fontSize: 14,
        fontColor: "#333",
        fontWeight: '600',
        fontFamily: "SF Pro Display, sans-serif",
        text: ''
      },
      xAxis: {
        labels: {
          fontColor: "#333",
          fontSize: 10,
          fontWeight: '700',
          fontFamily: 'var(--font-title)'
        },
        stroke: "#e0e0e0"
      },
      yAxis: {
        labels: {
          fontColor: "#333",
          fontSize: 10,
          fontWeight: '700',
          fontFamily: 'var(--font-title)'
        },
        stroke: "#e0e0e0"
      }
    };

    // Merge base config with specific settings, allowing overrides
    return {
      ...baseConfig,
      ...specificSettings,
      xAxis: {
        ...baseConfig.xAxis,
        ...specificSettings.xAxis,
        labels: {
          ...baseConfig.xAxis.labels,
          ...specificSettings.xAxis?.labels
        }
      },
      yAxis: {
        ...baseConfig.yAxis,
        ...specificSettings.yAxis,
        labels: {
          ...baseConfig.yAxis.labels,
          ...specificSettings.yAxis?.labels
        }
      }
    };
  }
};


export const scatterConfigJson = {
  apply: (config)=>{
    return {
      xGrid: {
        enabled: true,
        stroke: '#e5e5e5'
      },
      xMinorGrid: {
        enabled: true,
        stroke: '#f1f1f1'
      },
      yGrid: {
        enabled: true,
        stroke: '#e5e5e5'
      },
      yMinorGrid: {
        enabled: true,
        stroke: '#f1f1f1'
      },
        labels: {
          enabled: config?.showLabels ?? true, // Enable labels for markers
          format: "{%name}", // Assuming 'Value' is the field in your data items
          position: "top", // Set the position of labels
          fontSize: 13, // Font size of the labels
          fontColor: "#4E6574", // Font color of the labels
          fontFamily: "Inter, sans-serif", // Font family of the labels
          offsetY: 15,
          fontWeight: '600'

      }
    }
  }
}



export const baseBarColumnConfigJson = {
  pointWidth: '50%'
}

export const barConfigJson = {
  xGrid: {
    enabled: false,
  },
  xMinorGrid: {
    enabled: false,
  },
  yGrid: {
    enabled: true,
    stroke: '#e5e5e5'
  },
  yMinorGrid: {
    enabled: true,
    stroke: '#f1f1f1'
  },
  ...baseBarColumnConfigJson
}